import React from 'react'
import './ProjectsMain.css'

function main() {
  return (
    <>
      <div className="ProjectsTop">
        <h1>PROJECTS</h1>
        <img src="/project.png" alt="Project" />
      </div>
      <hr />
      <div className="bottom">
        <div className="project-box">
          <div className="project-card">
            <img src="/LoginProject.png" alt="img" />
            <p>Simple Login Page using HTML & CSS</p>
            <a href="https://drive.google.com/drive/folders/1k5YWdFe9IjbstEJHvhiZYEVmbTNfVCJr?usp=drive_link" target='_blank' rel="noreferrer">
              <button className='btn'>Get Code</button>
            </a>
          </div>
          <div className="project-card">
            <img src="/LoginProject1.png" alt="img" />
            <p>Simple Login Page using HTML & CSS</p>
            <a href="https://drive.google.com/drive/folders/1b6P0Wic8XXaL1e67D1DcLSDVWZUi4Efa?usp=drive_link" target='_blank' rel="noreferrer">
              <button className='btn'>Get Code</button>
            </a>
          </div>
          <div className="project-card">
            <img src="/transparentLogin.png" alt="img" />
            <p>Simple transparent Login Page using HTML & CSS</p>
            <a href="https://drive.google.com/drive/folders/1k8Xmpxcf-fJNZ7nzbU79TRHaFMLO_IC7?usp=drive_link" target='_blank' rel="noreferrer">
              <button className='btn'>Get Code</button>
            </a>
          </div>
        </div>
        <div className="project-box">
          <div className="project-card">
            <img src="/eduford.png" alt="img" />
            <p>Simple Educational Website using HTML, CSS & JavaScript</p>
            <div >
              <a href="https://adarshku.000webhostapp.com/index.html" target='_blank' rel="noreferrer">
                <button className='btn'>Visit Website</button>
              </a>
              <a href="https://drive.google.com/drive/folders/1QcTeiV4E7eoJMRpgI9wUH_4OkVwyuhtn?usp=drive_link" target='_blank' rel="noreferrer">
                <button className='btn'>Get Code</button>
              </a>
            </div>
          </div>
          <div className="project-card">
            <img src="/PortfolioProject.png" alt="img" />
            <p>Simple Portfolio Website using HTML, CSS & JavaScript</p>
            <a href="https://drive.google.com/drive/folders/1V835bDh16N9SYzLecQaiBDw0uU_tngHl?usp=drive_link" target='_blank' rel="noreferrer">
              <button className='btn'>Get Code</button>
            </a>
          </div>
          <div className="project-card">
            <img src="/analog.png" alt="img" />
            <p>Simple Analog watch using HTML, CSS & JavaScript</p>
            <a href="https://drive.google.com/drive/folders/1oc64FxUQhPV-NmleeiVahTFWta7W0D9o?usp=drive_link" target='_blank' rel="noreferrer">
              <button className='btn'>Get Code</button>
            </a>
          </div>
        </div>
        <div className="project-box">
          <div className="project-card">
            <img src="/calculator.png" alt="img" />
            <p>Simple Calculator using HTML, CSS & JavaScript</p>
            <div >
              <a href="https://drive.google.com/drive/folders/1md9_RHsdPUspn33L1HTGdAw_LpKHYde-?usp=drive_link" target='_blank' rel="noreferrer">
                <button className='btn'>Get Code</button>
              </a>
            </div>
          </div>
          <div className="project-card">
            <img src="/colorPicker.png" alt="img" />
            <p>Random ColorPicker using HTML, CSS & JavaScript</p>
            <a href="https://drive.google.com/drive/folders/1z77z3UQoIvJ94ILCdjUxmX12xJtBGjzz?usp=drive_link" target='_blank' rel="noreferrer">
              <button className='btn'>Get Code</button>
            </a>
          </div>
          <div className="project-card">
            <img src="/Countdown.png" alt="img" />
            <p>Countdown timer using HTML, CSS & JavaScript</p>
            <a href="https://drive.google.com/drive/folders/1U5ef2D-pCx4lZqogrUuXTUjGqMHeXCeq?usp=drive_link" target='_blank' rel="noreferrer">
              <button className='btn'>Get Code</button>
            </a>
          </div>
        </div>
        <div className="project-box">
          <div className="project-card">
            <img src="/Navigation.png" alt="img" />
            <p>Navigation tab using HTML, CSS & JavaScript</p>
            <div >
              <a href="https://drive.google.com/drive/folders/1UnCBYbuDDtPtewx9NVJB2UFKTMEiTSKB?usp=drive_link" target='_blank' rel="noreferrer">
                <button className='btn'>Get Code</button>
              </a>
            </div>
          </div>
          <div className="project-card">
            <img src="/password.png" alt="img" />
            <p> Password Generator using HTML, CSS & JavaScript</p>
            <a href="https://drive.google.com/drive/folders/1afRpUIy3vmyOhwZQZYj4EQoUPZSfOjfN?usp=drive_link" target='_blank' rel="noreferrer">
              <button className='btn'>Get Code</button>
            </a>
          </div>
        </div>
      </div>
    </>
  )
}

export default main